import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';

import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { ActivatedRoute, Router } from '@angular/router';
import { DxButtonModule, DxFormComponent, DxFormModule, DxValidatorModule, DxSelectBoxModule, DxDateBoxModule } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { RestApiService } from '../../shared/services/rest-api.service';
import { JustificationReason } from '../../shared/models/justification-reason';
import { ToolbarService } from '../../shared/services/toolbar.service';
import { Worker } from '../../shared/models/worker';
import { alert, confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-permission',
    templateUrl: './permission.component.html',
    imports: [
    DxFormModule,
    DxButtonModule,
    DxValidatorModule,
    DxSelectBoxModule,
    DxDateBoxModule
],
    styleUrl: './permission.component.scss'
})
export class PermissionComponent implements OnInit {
  requestType = ['Ferie', 'Permesso'];
  causalOptions: JustificationReason[] = [];
  now: Date = new Date();
  isFerie = true;
  tenantId = Number(localStorage.getItem('tenantId'));
  workerNumber = localStorage.getItem('user')?.substring(3) ?? '';

  isCausalSelectDisabled = false;
  currentWorker: Worker | any;
  tipologiaDisabled = false;
  dataLoading = false;
  deleteEnabled = false;
  sendEnabled = true;
  controlsDisabled = false;

  justificationreasonId = 0;

  approverOfNotifications = false;  // per capire se l'utente è uno di quelli che può approvare le notifiche / permessi 

  justificationPermissionBox: JustificationReason[] =[];
  enteringEditingMode = false;

  staticCausalOptions = [
    { text: 'Accettato' },
    { text: 'Rifiutato' },
    { text: '' }
  ];
  idPermission: string | any;
  backSubscription: any;

  @ViewChild(DxFormComponent, { static: false }) dxForm!: DxFormComponent;
  formData: any = {
    requestType: this.requestType[0],
    startDay: this.now,
    endDay: null,
    day: this.now,
    startTimeString: this.now,
    endTimeString: this.now,    
    causal: '',
    justificationPermissionBox: []
  };
  

  constructor(private apiService: RestApiService, private router: Router, private toolbar: ToolbarService, private dataRouter: ActivatedRoute) {
    this.isFerie = this.formData.requestType === 'Ferie';
  }

  ngOnInit(): void {
    this.loadData();

    this.toolbar.PlusVisibleChanged(false)
    this.toolbar.BackVisibleChanged(true);
    this.backSubscription = this.toolbar.backClickedEvent.subscribe(() => this.Back());


   this.apiService.getJustificationReason(this.tenantId).subscribe(s => {
     s.forEach(justReason => {
       this.causalOptions.push({
         justificationReasonId: justReason.justificationReasonId,
         justificationReasonType: justReason.justificationReasonType,
         description: justReason.description,
         code: justReason.code
       })
     })


     /*
     const current = this.formData.causal;
     if (current) {
       const found = this.causalOptions.find(c =>
         c.code === current ||
         String(c.justificationReasonId) === String(current) ||
         c.description === current ||
         (typeof current === 'object' && c.justificationReasonId === current.justificationReasonId)
       );
       if (found) {
         this.formData.causal = found;
       }
     }
     */


     //this.requestType = [];

     //this.causalOptions.forEach(item => {
     //  this.requestType.push(item.justificationReasonType+"-"+item.description);
     //})
    });



    this.setFormDataFromRouteParams();
  }

  Back() {
    this.router.navigate(['/permissions']);
  }
  ngOnDestroy() {
    this.backSubscription.unsubscribe();
  }


  setFormDataFromRouteParams(): void {

    this.idPermission = this.dataRouter.snapshot.paramMap.get('permissionID');
    if (this.idPermission) {

      this.enteringEditingMode = true;

      //this.tipologiaDisabled = true;
      this.dataLoading = true;
      this.deleteEnabled = true;

      this.apiService.getCurrentWorker().subscribe(worker => {
        this.currentWorker = worker;


        this.apiService.getPermissionByID(this.idPermission).subscribe(permS => {
          permS.forEach(perm => {

            this.justificationreasonId = perm.justificationReasonId;

            // prima controllo se è di tipologia FERIE ( start Day è sempre compilato anche per permessi )
            if (perm.startDay != null) {
              this.formData.startDay = new Date(perm.startDay);
              this.formData.requestType = 'Ferie';
            }
            if (perm.endDay != null) {
              this.formData.endDay = new Date(perm.endDay);
              this.formData.requestType = 'Ferie';
            }
            this.formData.causal = perm.causal;

            this.causalOptions.forEach(x => {
              if (x.justificationReasonId == this.justificationreasonId) {
                this.formData.justificationPermissionBox = x;
              }
            });

            // POI controllo i Time ( che sono nulli Se è tipo ferie Mentre sono compilati se PERMESSO )
            if (perm.startTime != null) {
              this.formData.startTimeString = this.parseTime(perm.startTime);
              this.formData.requestType = 'Permesso';
            }
            if (perm.endTime != null) {
              this.formData.endTimeString = this.parseTime(perm.endTime);
              this.formData.requestType = 'Permesso';
            }

            this.formData.day = new Date(perm.startDay)



            this.isFerie = this.formData.requestType === 'Ferie';





            // controllo ulteriore finale per la visualizzazione del pulsante cancella ( ed invio per utente base )

            if (this.idPermission != null && this.currentWorker.canApproveJustification != null && this.currentWorker.canApproveJustification ) {
              // caso del "direttore" che può mettere una causale
              this.deleteEnabled = false;
              this.tipologiaDisabled = true;
              this.controlsDisabled = true;

              // nel caso interno in cui ha già indicato approvato o rifiutato 
              if (this.formData.causal != "") {
                this.sendEnabled = false;
              }

              this.approverOfNotifications = true; // mi salvo il fatto che è un utente che può approvare le notifiche 
            }

            if (this.idPermission != null && !this.currentWorker.canApproveJustification != null && this.currentWorker.canApproveJustification && this.formData.causal != "") {
              // caso utente base 
              this.deleteEnabled = false;
              this.sendEnabled = false;
              this.controlsDisabled = true;
              this.tipologiaDisabled = true;

              this.approverOfNotifications = false; // mi salvo il fatto che è un utente "base" 
            }
          })

        });

      });

    }

  }


  parseTime(timeString: string): Date {
    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  }


  //leggo le giustificazioni dal database
  loadData(): void {

    // recupero le informazioni dell' utente
    this.apiService.getCurrentWorker().subscribe(worker => {
      this.currentWorker = worker;

      if (this.currentWorker.canApproveJustification != null && this.currentWorker.canApproveJustification) {

        // caso in cui sono un direttore e posso indicare se ferie / permesso accettate oppure no
        this.isCausalSelectDisabled = false
        this.deleteEnabled = false;
      } else {

        //caso in cui sono un dipendente e inserisco la possibilita di mettere una ferie / permesso 
        this.isCausalSelectDisabled = true
        this.deleteEnabled = true;

        const id = this.dataRouter.snapshot.paramMap.get('permissionID');
        if (id == null)
        {
          this.deleteEnabled = false;
        }
      }


    });
  }


  displayCausal = (item: JustificationReason | null) => {
    if (!item) return '';

    if (item.description.trim().length > 0) {
      return `${item.description.trim()}`;
    }
    else {
      return `${ item.justificationReasonType.trim() }`
    }
    //return `${item.justificationReasonType.trim()} - ${item.description.trim()}`;
    // return `${item.justificationReasonType.trim()} - ${item.description.trim()} - ${item.code.trim()}`;
  };

  /*
  getCausalValue(): string {
    const c = this.formData.causal;
    if (!c) return '';
    if (typeof c === 'string') return c;
    // preferisci code, poi id, poi description
    return (c.code ?? (c.justificationReasonId != null ? String(c.justificationReasonId) : '') ?? c.description ?? '') as string;
  }
  */

  //  onTypeChange(value: string) {
  onTypeChange(value: JustificationReason) {
    this.formData.requestType = value.justificationReasonType;
    this.isFerie = value.justificationReasonType === 'Ferie';

    this.justificationreasonId = value.justificationReasonId;


    if (this.enteringEditingMode) // alla prima ripaertura del form in modifica non tocco nulla
    {
      this.enteringEditingMode = false;
      return;
    }

    if (this.isFerie) {
      // Se in modalità ferie, resettiamo le date
      this.formData.startDay = null;
      this.formData.endDay = null;

    } else {
      // Se in modalità permesso, impostiamo l'orario corrente
      if (this.formData.day == null) {
        this.formData.day = this.now;
      }
      if (!this.formData.startTimeString) {
        this.formData.startTimeString = this.now; // Ora corrente se non è già definita
      }
      if (!this.formData.endTimeString) {
        this.formData.endTimeString = this.now; // Ora corrente se non è già definita
      }

    }
  }


  onFormSubmit = () => {

    if (this.idPermission != null) {
      // nel caso in cui sto modificando una "card" già inviata
      // che sià l'utente stesso oppure che sia "direttore" per approvazione

      if (this.isFerie) {
        // Caso Ferie
        const ferieRequest = {
          id: this.idPermission,
          tenantId: this.tenantId,
          workerNumber: this.workerNumber,
          startDay: this.formatDate(this.formData.startDay),
          endDay: this.formatDate(this.formData.endDay),
          causal: this.formData.causal,
          justificationReasonId: this.justificationreasonId
        };

        //---- 
        this.apiService.aggiornaFerie(ferieRequest).subscribe(() => {
          notify('Modifica ferie inviata con successo', 'success', 3000);

          this.router.navigate(['/permissions']);
        });

      } else {
        // Caseo Permessi
        const permessoRequest = {
          id: this.idPermission,
          tenantId: this.tenantId,
          workerNumber: this.workerNumber,
          day: this.formData.day,

          startTimeString: this.formatTime(this.formData.startTimeString),
          endTimeString: this.formatTime(this.formData.endTimeString),
          causal: this.formData.causal,
          justificationReasonId: this.justificationreasonId
        };


        this.apiService.aggiornaPermessi(permessoRequest).subscribe(() => {
          notify('Modifica permesso inviata con successo', 'success', 3000);

          this.router.navigate(['/permissions']);
        });

      }


    }
    else {
      // caso standard di inserimento 

      if (this.isFerie) {
        // controlli gruppo ferie 

        const ferieRequest = {
          tenantId: this.tenantId,
          workerNumber: this.workerNumber,
          startDay: this.formatDate(this.formData.startDay),
          endDay: this.formatDate(this.formData.endDay),
          causal: this.formData.causal,
          justificationReasonId: this.justificationreasonId
        };

        if (ferieRequest.startDay <= ferieRequest.endDay) {
          this.apiService.postLeave(ferieRequest).subscribe(() => {
            notify('Richiesta ferie inviata con successo', 'success', 3000);

            this.router.navigate(['/permissions']);
          });

        } else {
          notify('Impossibile inserire una data di inizio ferie maggiore della data di fine')
        }

      } else {
        // controlli gruppo premessi


        const permessoRequest = {
          tenantId: this.tenantId,
          workerNumber: this.workerNumber,
          day: this.formData.day,
          startTimeString: this.formatTime(this.formData.startTimeString),
          endTimeString: this.formatTime(this.formData.endTimeString),
          causal: this.formData.causal,
          justificationReasonId: this.justificationreasonId
        };

        if (permessoRequest.startTimeString <= permessoRequest.endTimeString) {

          this.apiService.postPermission(permessoRequest).subscribe(() => {
            notify('Richiesta permesso inviata con successo', 'success', 3000);

            this.router.navigate(['/permissions']);
          });
        }
        else {
          notify('Impossibile inserire un orario di inizio permesso maggiore di un orario di fine ');
        }
      }
    }
  };

  deletePerm = () => {
    if (this.idPermission != null) {

      confirm("Confermi l' operazione di eliminazione?", "Conferma Eliminazione")
        .then((dialogResult) => {
          if (dialogResult) {
            // ho premuto OK
            this.apiService.deletePermission(this.idPermission).subscribe(() => {
              this.router.navigate(['/permissions']);
            });

          }
        });
    }
  }

  registerButtonOptions: DxButtonTypes.Properties = {
    text: 'Invia',
    type: 'success',
    width: '120px',
    useSubmitBehavior: true,
    onClick: () => {
      const validationResult = this.dxForm.instance.validate();
      if (validationResult.isValid) {
        this.onFormSubmit();
      }
    }
  };

  deletePermission: DxButtonTypes.Properties = {
    text: 'Cancella',
    type: 'danger',
    width: '120px',
    useSubmitBehavior: false,
    onClick: () => {
      this.deletePerm();
    }
  };


  formatTime(date: Date): string {
    // Restituisce solo HH:mm
    if (!date) return '';
    return date.toTimeString().split(' ')[0].substring(0, 5);
  }

  formatDate(date: Date): string {
    // prende solo la parte yyyy-MM-dd

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Mesi da 0 a 11, aggiungi 1
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }


  onStartDayChanged = (e: any): void => {
    // 'e.value' contiene la data selezionata in startDay

    if (e.value && !this.dataLoading) {
      // Set endDay 
      this.formData.endDay = e.value;
    } else {

      if (!this.dataLoading) {
        this.formData.endDay = null;
      } else {
        this.dataLoading = false;
      }
    }
  }


  validateStartDayAsync = (params: any): Promise<boolean> => {

    const startDayValue = params.value;
    //const endDayValue = params.value;

    let idsel: string;
    if (this.idPermission) { idsel = this.idPermission; }
    else { idsel = "-1"; }


    const ferieRequest = {
      id: idsel,
      tenantId: this.tenantId,
      workerNumber: this.workerNumber,
      startDay: this.formatDate(startDayValue),
      endDay: this.formatDate(startDayValue),
      causal: this.formData.causal
    };

    return new Promise((resolve) => {
      this.apiService.postLeaveValidationStart(ferieRequest).subscribe({
        next: () => {
          resolve(true);
        },
        error: (error: any) => {
          // 400 bad request
          if (ferieRequest.causal == "") {

            if (error.status == 400 && error.error) {
              notify(error.error, 'error', 6000);
              resolve(false);
            } else {
              //console.error('Errore durante la validazione delle ferie:', error);
              notify('Data inizio ferie già presente ed approvata.', 'error', 6000);
              resolve(false);
            }

          }
          else {
            resolve(true);
          }
        }
      });

    });

  }

  validateEndDayAsync = (params: any): Promise<boolean> => {

    if (this.formData.startDay == null) { this.formData.startDay = params.value; }

    const endDayValue = params.value;
    const startDayValue = this.formData.startDay;

    let idsel: string;

    if (this.idPermission) { idsel = this.idPermission; }
    else { idsel = "-1"; }

    const ferieRequest = {
      id: idsel,
      tenantId: this.tenantId,
      workerNumber: this.workerNumber,
      startDay: this.formatDate(startDayValue),
      endDay: this.formatDate(endDayValue),
      causal: this.formData.causal
    };


    return new Promise((resolve) => {
      this.apiService.postLeaveValidationEnd(ferieRequest).subscribe({
        next: () => {
          resolve(true);
        },
        error: (error: any) => {
          if (ferieRequest.causal == "") {

            if (error.status == 400 && error.error) {
              notify(error.error, 'error', 6000);
              resolve(false);
            } else {
              notify('Data fine ferie gia presente ed approvata.', 'error', 6000);
              resolve(false);
            }

          } else {
            resolve(true);
          }
        }
      });

    });


  }


}
